import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/sino-helpConfig/helpConfig/list',
        method: 'get',
        params: {
            ...params,
            current,
            size,
        }
    })
}

export const getDetail = (id) => {
    return request({
        url: '/api/sino-helpConfig/helpConfig/detail',
        method: 'get',
        params: {
            id
        }
    })
}

export const remove = (ids) => {
    return request({
        url: '/api/sino-helpConfig/helpConfig/remove',
        method: 'post',
        params: {
            ids,
        }
    })
}

export const add = (row) => {
    return request({
        url: '/api/sino-helpConfig/helpConfig/submit',
        method: 'post',
        data: row
    })
}

export const update = (row) => {
    return request({
        url: '/api/sino-helpConfig/helpConfig/submit',
        method: 'post',
        data: row
    })
}

export const getCmsList = () => {
    return request({
        url: '/api/sino-helpConfig/helpConfig/cmsMenuList',
        method: 'get',
    })
}

